import React from "react";

// Paragraph component that adjusts font size based on viewport width
const Paragraph = ({
  children,
  reduceBelow,
  maxFontSize,
  minFontSize,
  className = "",
  ...props
}) => {
  // Set default values for minFontSize, maxFontSize, and reduceBelow if not provided
  const minText = minFontSize ? minFontSize : 18;
  const maxText = maxFontSize ? maxFontSize : 38;
  const reduceBefore = reduceBelow ? reduceBelow : 1920;

  // Calculate the size reducer based on the maximum font size and the reduceBelow value
  const sizeReducer = (100 / reduceBefore) * maxText;

  return (
    <p
      {...props}
      // Set the font size using the clamp CSS function to ensure it adjusts between minText and maxText
      style={{
        fontSize: `clamp(${minText}px, ${sizeReducer}vw, ${maxText}px)`,
      }}
      // Apply additional class names and fixed styles
      className={`${className} font-normal sm:!leading-128 !leading-113 text-dark-purple`}
    >
      {children}
    </p>
  );
};

export default Paragraph;
